/* KURVESKUFFEN
   ------------------------------------------------------------------
   Laegger varen i kurven UDEN at forlade siden, og bekraefter den i en skuffe.
   Se begrundelsen i snippets/kurv-skuffe.liquid.

   Alt hviler paa Shopifys egne AJAX-ruter (/cart/add.js, /cart.js,
   /cart/change.js), saa der ikke findes en anden sandhed om kurven end den
   /cart-siden selv laeser. Skuffen tegnes fra /cart.js hver gang den aabnes.

   FALDBAR: sker der noget som helst uventet — ingen skuffe i DOM'en, et kald der
   fejler, et svar der ikke er JSON — saa faar formularen lov at poste som den
   altid har gjort, og man lander paa /cart. En kurv der ikke kan fyldes er en
   vaerre fejl end en kurv uden skuffe. */
(function () {
  "use strict";

  var skuffe = document.querySelector("[data-kurv-skuffe]");
  if (!skuffe) return;

  var krop = skuffe.querySelector("[data-kurv-krop]");
  var bund = skuffe.querySelector("[data-kurv-bund]");
  var kvit = skuffe.querySelector("[data-kurv-kvit]");
  var antalEl = skuffe.querySelector("[data-kurv-antal]");
  var sumEl = skuffe.querySelector("[data-kurv-sum]");
  var fragt = skuffe.querySelector("[data-kurv-fragt]");
  var sidstFokus = null;
  var henter = false;

  function kr(oere) {
    /* Shopifys money-filter kan ikke naas fra JS. Butikken koerer ÉN valuta og ét
       format ("179,00 kr."), saa det formateres her i stedet for at hente en
       formatstreng ned. Aendres valutaen, skal det her med. */
    var n = (oere / 100).toFixed(2).replace(".", ",");
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kr.";
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Titlen renses som paa produktkortet: maerket staar for sig, og stoerrelsen
     har sin egen linje. Reglerne er de samme som i snippets/product-card.liquid
     og assets/plp-filter.js — holdes de ikke i takt, hedder den samme vare tre
     forskellige ting tre steder paa sitet. */
  var ENHEDER = ["tabletter", "servietter", "breve", "stk", "ml", "cl", "kg", "gr", "oz", "cm", "mm", "g", "l"];
  function handleize(s) {
    return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }
  function udenMaerke(titel, maerke) {
    if (!maerke) return titel;
    var vh = handleize(maerke), ord = String(titel).split(" "), acc = "", drop = 0;
    for (var i = 0; i < Math.min(8, ord.length); i++) {
      var kand = acc ? acc + " " + ord[i] : ord[i];
      var h = handleize(kand);
      if (h && vh.slice(0, h.length) === h) { acc = kand; drop = i + 1; } else break;
    }
    var rest = ord.slice(drop).join(" ").trim();
    return drop > 0 && rest ? rest : titel;
  }
  function delSize(t) {
    t = String(t || "").trim();
    var ord = t.split(" "), n = ord.length;
    if (n < 2) return { str: "", ren: t };
    var afkort = function (k) { k = k.trim(); if (/[,\-:;]$/.test(k)) k = k.slice(0, -1).trim(); return k; };
    var sidste = ord[n - 1].toLowerCase().replace(/\)/g, "").replace(/[.,]$/, ""), tal, kand;
    if (n >= 3 && ENHEDER.indexOf(sidste) !== -1) {
      tal = parseFloat(ord[n - 2].replace("(", "").replace(",", "."));
      if (tal > 0) {
        kand = afkort(ord.slice(0, n - 2).join(" "));
        if (kand.length >= 8) return { str: ord[n - 2].replace("(", "").replace(".", ",") + " " + sidste, ren: kand };
      }
    }
    for (var i = 0; i < ENHEDER.length; i++) {
      var u = ENHEDER[i];
      if (sidste.length > u.length && sidste.slice(-u.length) === u) {
        var fl = sidste.length - u.length;
        tal = parseFloat(sidste.slice(0, fl).replace(",", "."));
        if (tal > 0) {
          kand = afkort(ord.slice(0, n - 1).join(" "));
          if (kand.length >= 8) return { str: sidste.slice(0, fl).replace(".", ",") + " " + u, ren: kand };
        }
        break;
      }
    }
    return { str: "", ren: t };
  }

  function linjeHTML(l, i) {
    var raa = udenMaerke(l.product_title || l.title, l.vendor);
    var d = delSize(raa);
    var foto = l.image ? '<img src="' + esc(l.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2")) + '" alt="" width="68" height="85" loading="lazy">' : "";
    return '<div class="kurv-linje" data-linje="' + (i + 1) + '">'
      + '<div class="kurv-linje__foto">' + foto + "</div>"
      + '<div class="kurv-linje__info">'
        + (l.vendor ? '<p class="kurv-linje__maerke">' + esc(l.vendor) + "</p>" : "")
        + '<a class="kurv-linje__navn" href="' + esc(l.url) + '">' + esc(d.ren) + "</a>"
        + (d.str ? '<p class="kurv-linje__str">' + esc(d.str) + "</p>" : "")
      + "</div>"
      + '<div class="kurv-linje__pris">' + kr(l.final_line_price) + "</div>"
      + '<div class="kurv-linje__antal">'
        + '<span class="kurv-linje__stepper">'
          + '<button type="button" data-kurv-minus aria-label="Færre">−</button>'
          + '<span class="kurv-linje__tal">' + l.quantity + "</span>"
          + '<button type="button" data-kurv-plus aria-label="Flere">+</button>'
        + "</span>"
        + '<button type="button" class="kurv-linje__fjern" data-kurv-fjern>Fjern</button>'
      + "</div>"
      + "</div>";
  }

  function tegn(kurv) {
    if (antalEl) antalEl.textContent = kurv.item_count ? "(" + kurv.item_count + ")" : "";
    if (!kurv.items || !kurv.items.length) {
      krop.innerHTML = '<p class="kurv-skuffe__tom">Der er ikke lagt noget i kurven endnu.</p>';
      if (bund) bund.hidden = true;
      return;
    }
    krop.innerHTML = kurv.items.map(linjeHTML).join("");
    if (bund) bund.hidden = false;
    if (sumEl) sumEl.textContent = kr(kurv.total_price);
    if (fragt) {
      var graense = parseInt(fragt.getAttribute("data-graense"), 10) || 0;
      var tekst = fragt.querySelector("[data-kurv-fragt-tekst]");
      var fyld = fragt.querySelector("[data-kurv-fragt-fyld]");
      if (graense > 0) {
        var mangler = graense - kurv.total_price;
        if (tekst) tekst.innerHTML = mangler > 0
          ? "Køb for <strong>" + kr(mangler) + "</strong> mere og få fri fragt."
          : "Du har fri fragt.";
        if (fyld) fyld.style.width = Math.min(100, (kurv.total_price / graense) * 100) + "%";
      }
    }
  }

  function badges(kurv) {
    /* Kurvens tal i headeren OG i mobilmenuen. Serveren har render'et dem, saa de
       skal opdateres her — ellers staar der stadig "2" efter man har fjernet alt. */
    var n = kurv.item_count;
    document.querySelectorAll(".site-header__cart .site-header__cart-badge").forEach(function (b) {
      b.textContent = n; b.hidden = n === 0;
    });
    document.querySelectorAll(".site-header__mobile-konto .site-header__mobile-tal:not([data-likes-badge])").forEach(function (b) {
      b.textContent = n; b.hidden = n === 0;
    });
    /* Findes taelleren slet ikke (kurven var tom da siden blev sendt), laves den. */
    var kn = document.querySelector(".site-header__cart");
    if (kn && n > 0 && !kn.querySelector(".site-header__cart-badge")) {
      var s = document.createElement("span");
      s.className = "site-header__cart-badge";
      s.textContent = n;
      kn.appendChild(s);
    }
  }

  function hent() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function aaben(besked) {
    sidstFokus = document.activeElement;
    skuffe.hidden = false;
    skuffe.setAttribute("aria-hidden", "false");
    document.body.classList.add("har-kurv-skuffe");
    if (kvit) {
      kvit.hidden = !besked;
      if (besked) kvit.textContent = besked;
    }
    var x = skuffe.querySelector(".kurv-skuffe__x");
    if (x) x.focus();
    opdater();
  }

  function luk() {
    skuffe.hidden = true;
    skuffe.setAttribute("aria-hidden", "true");
    document.body.classList.remove("har-kurv-skuffe");
    if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
  }

  function opdater() {
    if (henter) return;
    henter = true;
    return hent().then(function (kurv) {
      henter = false;
      tegn(kurv);
      badges(kurv);
    }).catch(function () { henter = false; });
  }

  function skift(linje, antal) {
    krop.style.opacity = "0.5";
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: linje, quantity: antal }),
    }).then(function (r) { return r.json(); }).then(function (kurv) {
      krop.style.opacity = "";
      tegn(kurv);
      badges(kurv);
      if (kvit) kvit.hidden = true;
    }).catch(function () {
      krop.style.opacity = "";
      /* Kunne vi ikke aendre den, er /cart stadig sandheden — send brugeren dertil
         frem for at lade skuffen vise noget der ikke passer. */
      location.href = "/cart";
    });
  }

  /* --- laeg i kurv fra PDP'en --- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest ? e.target.closest(".pdp__buy") : null;
    if (!form) return;
    e.preventDefault();
    var knap = form.querySelector('button[type="submit"], .pdp__add');
    if (knap) knap.setAttribute("disabled", "");
    fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function (vare) {
        if (knap) knap.removeAttribute("disabled");
        var navn = vare && (vare.product_title || vare.title) ? delSize(udenMaerke(vare.product_title || vare.title, vare.vendor)).ren : "Varen";
        aaben(navn + " er lagt i kurven.");
      })
      .catch(function () {
        /* Faldbar: lad formularen goere det den altid har gjort. */
        if (knap) knap.removeAttribute("disabled");
        form.submit();
      });
  });

  /* --- kurve-ikonet i headeren aabner skuffen i stedet for at navigere --- */
  document.addEventListener("click", function (e) {
    var ikon = e.target.closest ? e.target.closest(".site-header__cart") : null;
    if (ikon && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      aaben("");
      return;
    }
    if (e.target.closest && e.target.closest("[data-kurv-luk]")) { e.preventDefault(); luk(); return; }

    var linjeEl = e.target.closest ? e.target.closest(".kurv-linje") : null;
    if (!linjeEl) return;
    var nr = parseInt(linjeEl.getAttribute("data-linje"), 10);
    var nu = parseInt(linjeEl.querySelector(".kurv-linje__tal").textContent, 10) || 1;
    if (e.target.closest("[data-kurv-plus]")) { e.preventDefault(); skift(nr, nu + 1); }
    else if (e.target.closest("[data-kurv-minus]")) { e.preventDefault(); skift(nr, Math.max(0, nu - 1)); }
    else if (e.target.closest("[data-kurv-fjern]")) { e.preventDefault(); skift(nr, 0); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !skuffe.hidden) luk();
  });

  /* Concierge'en laegger ogsaa i kurven (assets/concierge-ui.js). Den fyrer intet
     i dag, men naar den goer, skal skuffen vise resultatet i stedet for at lade
     taelleren staa forkert. */
  document.addEventListener("endorse:cart-changed", function () { opdater(); });
})();
